import { ROLE_LEVELS, usePermissionContext } from "@/permissions";
import { StepCardWrapper } from "./StepCardWrapper";
import { Edit } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import SelectedMaskDetails from "../SelectedMaskDetails";
import { EditMaskDialog } from "../maskDialog/MaskDialog";

type MaskDetailsStepCardProps = {
  selectedMaskId?: string;
  projectMasks: any[];
  project: any;
  pcmVersions: any[];
  chipPos: any[];
};

export function MaskDetailsStepCard({
  selectedMaskId,
  projectMasks,
  project,
  pcmVersions,
  chipPos,
}: MaskDetailsStepCardProps) {
  const [isEditMaskOpen, setIsEditMaskOpen] = useState(false);

  return (
    <StepCardWrapper
      title="Mask Details"
      headerChildren={
        selectedMaskId && <MaskEditButton onEditClick={() => setIsEditMaskOpen(true)} />
      }
    >
      {selectedMaskId && (
        <SelectedMaskDetails projectMasks={projectMasks} selectedMaskId={selectedMaskId} />
      )}
      {isEditMaskOpen && selectedMaskId && (
        <EditMaskDialog
          chipPosCount={chipPos.length}
          mask={projectMasks.find((m) => m.id === selectedMaskId)}
          maskId={selectedMaskId}
          onOpenChange={setIsEditMaskOpen}
          open
          pcmVersions={pcmVersions}
          project={project}
        />
      )}
    </StepCardWrapper>
  );
}

// Edit button component that checks for project manager role
function MaskEditButton({ onEditClick }: { onEditClick: () => void }) {
  const { getRoleLevel } = usePermissionContext();
  const canEdit = getRoleLevel() >= ROLE_LEVELS.PROJECT_MANAGER;

  if (!canEdit) return null;

  return (
    <Button variant="ghost" size="sm" onClick={onEditClick} className="h-6 w-6 p-0">
      <Edit className="w-4 h-4" />
    </Button>
  );
}
